jQuery(document).ready(function($) {
    $(document).on('click', '.rewards-popup-trigger', function(){
        console.log('popup-trigger')
    })
})